import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const translationApi = createApi({
  reducerPath: "translation",
  baseQuery: fetchBaseQuery({
    baseUrl: window.location.origin,
    withCredentials: true
  }),
  endpoints: build => ({
    getTranslations: build.query({
      query: () => '/api/Localization/GetTranslations'
    })
  })
})

export const { useGetTranslationsQuery } = translationApi
